document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('[data-nutrition-package-popup]');
  const openButton = document.getElementById('nutrition-package-popup-trigger');
  const downloadButton = document.getElementById('nutrition-package-download');

  if (!popup || !openButton || !downloadButton) return;

  const closeButtons = popup.querySelectorAll('[data-nutrition-package-close]');
  const content = popup.querySelector('[data-nutrition-package-content]');
  const pdfJsModuleUrl = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@5.7.284/build/pdf.min.mjs';
  const pdfJsWorkerUrl = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@5.7.284/build/pdf.worker.min.mjs';
  let pdfJsPromise = null;
  let renderSequence = 0;

  function loadPdfJs() {
    if (!pdfJsPromise) {
      pdfJsPromise = import(pdfJsModuleUrl).then(pdfjsLib => {
        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfJsWorkerUrl;
        return pdfjsLib;
      });
    }
    return pdfJsPromise;
  }

  function getVisibleNutritionPackages() {
    return Array.from(popup.querySelectorAll('.nutrition-package[data-nutrition-pdf]'))
      .filter(packageElement =>
        !packageElement.hidden &&
        !packageElement.closest('[data-nutrition-hidden-by-external]') &&
        getComputedStyle(packageElement).display !== 'none'
      );
  }

  function getVisibleNutritionPackage() {
    return getVisibleNutritionPackages()[0] || null;
  }

  function updateDownloadButton() {
    downloadButton.disabled = !getVisibleNutritionPackage();
  }

  function cropCanvasToArtwork(sourceCanvas) {
    const context = sourceCanvas.getContext('2d', { willReadFrequently: true });
    const { width, height } = sourceCanvas;
    const pixels = context.getImageData(0, 0, width, height).data;
    const sampleStep = Math.max(2, Math.round(Math.min(width, height) / 1000));
    const whiteThreshold = 248;
    let left = width;
    let right = -1;
    let top = height;
    let bottom = -1;

    for (let y = 0; y < height; y += sampleStep) {
      for (let x = 0; x < width; x += sampleStep) {
        const index = (y * width + x) * 4;
        if (
          pixels[index] < whiteThreshold ||
          pixels[index + 1] < whiteThreshold ||
          pixels[index + 2] < whiteThreshold
        ) {
          if (x < left) left = x;
          if (x > right) right = x;
          if (y < top) top = y;
          if (y > bottom) bottom = y;
        }
      }
    }

    if (right < left || bottom < top) return sourceCanvas;

    const padding = sampleStep * 2;
    left = Math.max(0, left - padding);
    top = Math.max(0, top - padding);
    right = Math.min(width - 1, right + padding);
    bottom = Math.min(height - 1, bottom + padding);

    const croppedWidth = right - left + 1;
    const croppedHeight = bottom - top + 1;
    const croppedCanvas = document.createElement('canvas');
    croppedCanvas.width = croppedWidth;
    croppedCanvas.height = croppedHeight;
    croppedCanvas.getContext('2d', { alpha: false }).drawImage(
      sourceCanvas,
      left,
      top,
      croppedWidth,
      croppedHeight,
      0,
      0,
      croppedWidth,
      croppedHeight
    );
    return croppedCanvas;
  }

  async function renderNutritionPackage(nutritionPackage, currentSequence) {
    const pdfUrl = nutritionPackage?.dataset?.nutritionPdf;
    const pagesElement = nutritionPackage?.querySelector('[data-nutrition-pdf-pages]');
    if (!nutritionPackage || !pdfUrl || !pagesElement) return;

    const targetWidth = Math.round(nutritionPackage.clientWidth);
    if (!targetWidth) return;
    if (
      nutritionPackage.dataset.pdfRenderedUrl === pdfUrl &&
      Number(nutritionPackage.dataset.pdfRenderedWidth) === targetWidth
    ) return;

    try {
      const pdfjsLib = await loadPdfJs();
      const pdf = await pdfjsLib.getDocument({ url: pdfUrl }).promise;
      const canvases = [];
      const pixelRatio = window.matchMedia('(max-width: 768px)').matches
        ? 8
        : Math.min(window.devicePixelRatio || 1, 4);

      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber += 1) {
        if (currentSequence !== renderSequence) return;

        const page = await pdf.getPage(pageNumber);
        const baseViewport = page.getViewport({ scale: 1 });
        const cssScale = targetWidth / baseViewport.width;
        const renderViewport = page.getViewport({ scale: cssScale * pixelRatio });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d', { alpha: false });

        canvas.width = Math.ceil(renderViewport.width);
        canvas.height = Math.ceil(renderViewport.height);

        await page.render({ canvasContext: context, viewport: renderViewport }).promise;
        const displayCanvas = cropCanvasToArtwork(canvas);
        displayCanvas.className = 'nutrition-package__page';
        displayCanvas.style.width = `${targetWidth}px`;
        displayCanvas.style.height = `${Math.round(targetWidth * displayCanvas.height / displayCanvas.width)}px`;
        canvases.push(displayCanvas);
      }

      if (currentSequence !== renderSequence) return;
      pagesElement.replaceChildren(...canvases);
      nutritionPackage.dataset.pdfRenderedUrl = pdfUrl;
      nutritionPackage.dataset.pdfRenderedWidth = String(targetWidth);
      nutritionPackage.classList.add('is-rendered');
    } catch (error) {
      nutritionPackage.classList.remove('is-rendered');
    }
  }

  async function renderVisiblePdfs() {
    const visiblePackages = getVisibleNutritionPackages();
    if (!visiblePackages.length) return;

    const currentSequence = ++renderSequence;
    await Promise.all(
      visiblePackages.map(nutritionPackage =>
        renderNutritionPackage(nutritionPackage, currentSequence)
      )
    );
  }

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nutrition-package-popup-open');
    updateDownloadButton();
    requestAnimationFrame(renderVisiblePdfs);
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nutrition-package-popup-open');
    const focusTarget = externalOpener || openButton;
    clearExternalPackages();
    focusTarget.focus({ preventScroll: true });
  }

  // Render the popup from <body> so it can sit above other popups (e.g. compare).
  if (popup.parentElement !== document.body) document.body.appendChild(popup);

  // Packages of another product (e.g. a compare column), shown instead of the current product's ones.
  let externalWrapper = null;
  let externalOpener = null;

  function clearExternalPackages() {
    if (externalWrapper) externalWrapper.remove();
    externalWrapper = null;
    externalOpener = null;
    if (!content) return;
    content.querySelectorAll('[data-nutrition-hidden-by-external]').forEach(element => {
      element.style.display = '';
      element.removeAttribute('data-nutrition-hidden-by-external');
    });
  }

  function createExternalPackage({ url, handle }) {
    const nutritionPackage = document.createElement('div');
    nutritionPackage.className = 'labels-container nutrition-package';
    nutritionPackage.dataset.nutritionPdf = url;
    nutritionPackage.dataset.nutritionFilename = `${handle || 'nutrition'}-nutrition.pdf`;

    const pages = document.createElement('div');
    pages.className = 'nutrition-package__pages';
    pages.setAttribute('data-nutrition-pdf-pages', '');

    const documentFrame = document.createElement('iframe');
    documentFrame.className = 'nutrition-package__document';
    documentFrame.src = `${url}#page=1&zoom=page-width&view=FitH`;
    documentFrame.title = handle || '';
    documentFrame.loading = 'lazy';

    const fallback = document.createElement('a');
    fallback.className = 'nutrition-package__fallback';
    fallback.href = url;
    fallback.target = '_blank';
    fallback.rel = 'noopener';
    fallback.textContent = handle || url;

    nutritionPackage.append(pages, documentFrame, fallback);
    return nutritionPackage;
  }

  window.openNutritionPackagePopup = function (pdfs, opener) {
    if (!content || !Array.isArray(pdfs) || !pdfs.length) return;

    clearExternalPackages();
    Array.from(content.children).forEach(element => {
      element.setAttribute('data-nutrition-hidden-by-external', '');
      element.style.display = 'none';
    });

    externalWrapper = document.createElement('div');
    externalWrapper.className = 'nutrition-package-wrapper';
    pdfs.forEach(pdf => externalWrapper.appendChild(createExternalPackage(pdf)));
    content.appendChild(externalWrapper);
    externalOpener = opener || null;

    openPopup();
  };

  openButton.addEventListener('click', openPopup);
  closeButtons.forEach(button => button.addEventListener('click', closePopup));

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  downloadButton.addEventListener('click', async function () {
    const nutritionPackages = getVisibleNutritionPackages();
    if (!nutritionPackages.length) return;

    downloadButton.classList.add('loading');

    try {
      const results = await Promise.allSettled(nutritionPackages.map(async (nutritionPackage, index) => {
        const pdfUrl = nutritionPackage.dataset.nutritionPdf;
        const response = await fetch(pdfUrl);
        if (!response.ok) throw new Error(`PDF download failed: ${response.status}`);

        return {
          blobUrl: URL.createObjectURL(await response.blob()),
          filename: nutritionPackage.dataset.nutritionFilename || `nutrition-${index + 1}.pdf`
        };
      }));

      const downloads = results
        .filter(result => result.status === 'fulfilled')
        .map(result => result.value);

      downloads.forEach((download, index) => {
        setTimeout(() => {
          const link = document.createElement('a');
          link.href = download.blobUrl;
          link.download = download.filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(() => URL.revokeObjectURL(download.blobUrl), 1000);
        }, index * 150);
      });

      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          window.open(nutritionPackages[index].dataset.nutritionPdf, '_blank', 'noopener');
        }
      });
    } catch (error) {
      nutritionPackages.forEach(nutritionPackage => {
        window.open(nutritionPackage.dataset.nutritionPdf, '_blank', 'noopener');
      });
    } finally {
      downloadButton.classList.remove('loading');
    }
  });

  if (content) {
    new MutationObserver(function (mutations) {
      const onlyCanvasUpdates = mutations.every(mutation =>
        mutation.target.closest?.('[data-nutrition-pdf-pages]')
      );
      if (onlyCanvasUpdates) return;

      updateDownloadButton();
      if (popup.classList.contains('is-open')) requestAnimationFrame(renderVisiblePdfs);
    }).observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'hidden']
    });
  }

  let resizeTimer = null;
  window.addEventListener('resize', function () {
    if (!popup.classList.contains('is-open')) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(renderVisiblePdfs, 150);
  });

  updateDownloadButton();

  // Links from other pages (e.g. compare popup) use ?popup=label to open the label directly.
  const pageUrl = new URL(window.location.href);
  if (pageUrl.searchParams.get('popup') === 'label') {
    openPopup();
    pageUrl.searchParams.delete('popup');
    window.history.replaceState(window.history.state, '', pageUrl.pathname + pageUrl.search + pageUrl.hash);
  }
});

